import { asyncLazySingleton } from '../_common/common';
import {ConvocationResignationsApi} from "../_api/ilerna-StudentAccount/src";

export const convocationResignations = new asyncLazySingleton(async () => new ConvocationResignationsApi());
